"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconReturn = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconReturn = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.724 8.307V3L.5 11.845l9.224 8.845v-5.307c.74 0 1.455.032 2.149.093 3.722.331 6.95 1.541 9.462 3.521.812.641 1.399 1.03 2.148 2.003 0-.973.166-1.768-.547-3.293-2.148-4.598-6.203-8.43-13.212-9.4Zm8.997 6.762a12.964 12.964 0 0 0-.216-.241c-2.006-2.184-4.897-3.87-9.083-4.45l-1.846-.255V7.996l-4.014 3.85 4.014 3.848v-2.403h2.148c3.402 0 6.393.612 8.997 1.778Z"
}));
exports.IconReturn = IconReturn;
//# sourceMappingURL=IconReturn.js.map